
import React, { Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

let resolve;

const classNames = mergeStyleSets({
    warning: {
        paddingLeft: '8px',
        color: 'red'
    }
});


const Warning = (props) => {
    return (
        <div className={classNames.warning}>{props.message}</div>
    );
}

const Warnings = (props) => {
    return (
        <div>
            {props.warnings.map((item, index) => {
                return <Warning key={index} message={item} />;
            })}
        </div>
    );
}

class DialogCreateProject extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogCreateProject/>, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            sourceId: '',
            sourceType: 1,
            title: '',
            warnings: []
        };
    }

    checkValues() {
        let warnings = [];
        if (!this.state.title) {
            warnings.push('Není zadaný název projektu');
        }
        if (!this.state.sourceId) {
            warnings.push('Není zadané ID zdroje dat');
        }
        this.setState({warnings: warnings});
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                title: this.state.title,
                sourceType: this.state.sourceType,
                sourceId: this.state.sourceId
            });
        }
    }

    handleOnChangeTitle = (event) => {
        this.setState({title: event.target.value});
    }

    handleOnChangeSourceId = (event) => {
        this.setState({sourceId: event.target.value});
    }

    handleOnChangeSourceType = (event) => {
        this.setState({sourceType: event.target.value});
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Vytvoření nového projektu"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                <div>
                    <TextField
                        label="Název projektu"
                        value={this.state.title}
                        onChange={this.handleOnChangeTitle}
                        onKeyDown={this.handleOnKeyDown}
                    />
                    <ComboBox
                        label="Typ zdroje dat"
                        options={[
                            {key: 1, text: 'webHONITBA'}
                        ]}
                        onChange={this.handleOnChangeSourceType}
                        selectedKey={this.state.sourceType}
                    />

                    <TextField
                        label="ID zdroje dat"
                        value={this.state.sourceId}
                        onChange={this.handleOnChangeSourceId}
                        onKeyDown={this.handleOnKeyDown}
                    />
                    <Warnings warnings={this.state.warnings} />
                </div>
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Vytvořit" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show() {
        this.setState({
            hidden: false,
            title: '',
            sourceId: '',
            sourceType: 1,
            warnings: []
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogCreateProject.create();
